/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getProductSampleRequest = /* GraphQL */ `
  query GetProductSampleRequest($id: ID!) {
    getProductSampleRequest(id: $id) {
      id
      distributor_name
      distributor_code
      distributor_phone
      distributor_email
      brand_name
      product_name
      price_ex_vat
      registered_region
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const listProductSampleRequests = /* GraphQL */ `
  query ListProductSampleRequests(
    $filter: ModelProductSampleRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductSampleRequests(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        distributor_name
        distributor_code
        distributor_phone
        distributor_email
        brand_name
        product_name
        price_ex_vat
        registered_region
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncProductSampleRequests = /* GraphQL */ `
  query SyncProductSampleRequests(
    $filter: ModelProductSampleRequestFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncProductSampleRequests(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        distributor_name
        distributor_code
        distributor_phone
        distributor_email
        brand_name
        product_name
        price_ex_vat
        registered_region
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const getProduct = /* GraphQL */ `
  query GetProduct($id: ID!) {
    getProduct(id: $id) {
      id
      brand_name
      product_name
      registered_region
      style
      price_ex_vat
      bottles_per_year
      year_of_production
      container_size_cl
      abv_percentage
      tags
      product_image
      other_images
      techSheetDescription
      techSheetProductType
      techSheetSoil
      techSheetProductionArea
      techSheetFormat
      techSheetAgingCapacity
      techSheetYearOfPlanting
      techSheetVinification
      techSheetAppearance
      techSheetNose
      techSheetPalate
      techSheetPairings
      techSheetServingTemperatureMin
      techSheetServingTemperatureMax
      techSheetCertifications
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      owner
      __typename
    }
  }
`;
export const listProducts = /* GraphQL */ `
  query ListProducts(
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        brand_name
        product_name
        registered_region
        style
        price_ex_vat
        bottles_per_year
        year_of_production
        container_size_cl
        abv_percentage
        tags
        product_image
        other_images
        techSheetDescription
        techSheetProductType
        techSheetSoil
        techSheetProductionArea
        techSheetFormat
        techSheetAgingCapacity
        techSheetYearOfPlanting
        techSheetVinification
        techSheetAppearance
        techSheetNose
        techSheetPalate
        techSheetPairings
        techSheetServingTemperatureMin
        techSheetServingTemperatureMax
        techSheetCertifications
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
export const syncProducts = /* GraphQL */ `
  query SyncProducts(
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
    $lastSync: AWSTimestamp
  ) {
    syncProducts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      lastSync: $lastSync
    ) {
      items {
        id
        brand_name
        product_name
        registered_region
        style
        price_ex_vat
        bottles_per_year
        year_of_production
        container_size_cl
        abv_percentage
        tags
        product_image
        other_images
        techSheetDescription
        techSheetProductType
        techSheetSoil
        techSheetProductionArea
        techSheetFormat
        techSheetAgingCapacity
        techSheetYearOfPlanting
        techSheetVinification
        techSheetAppearance
        techSheetNose
        techSheetPalate
        techSheetPairings
        techSheetServingTemperatureMin
        techSheetServingTemperatureMax
        techSheetCertifications
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
  }
`;
